export const permissionData = [
  {
    type: '超管',
    id: 'EeFDC299-f42b-8cc7-1bfB-dF189C655661',
    permission: [
      'root',
      '8a7480426fa34894016fa721b5c000f1',
      '8a7480426fa34894016fa721b5c000f2',
      '8a7480426fa34894016fa721b5c000f3',
      '8a7480426fa34894016fa721b5c000f4',
      '8a7480426fa34894016fa721b5c000f41',
      '8a7480426fa34894016fa721b5c000f42',
      '8a7480426fa34894016fa721b5c000f43',
      '8a7480426fa34894016fa721b5c000g1'
    ]
  },
  {
    type: '用户',
    id: 'C82CB616-1173-2eA6-4dD1-b92EfF2406eb'
  },
  {
    type: '访客',
    id: 'E59Dcfb1-0d6b-11C2-F884-6FC26e9815C3',
    permission: [
      'root',
      '8a7480426fa34894016fa721b5c000g1'
    ]
  }
];
